import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Import necessary parts from react-router and history
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';

// Create a history object for the router to use
const history = createBrowserHistory({ window });

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wrap the App in HistoryRouter and enable ALL future flags to opt-in to v7 features.
// This will remove all warnings from the browser console.
root.render(
  <React.StrictMode>
    <HistoryRouter
      history={history}
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true, // Add this flag to resolve the warning
      }}
    >
      <App />
    </HistoryRouter>
  </React.StrictMode>
);
